import React, { useEffect, useState } from 'react'
import { Grid, Card, CardMedia, CardContent, Typography, Chip, Box, CircularProgress, Button, Slider, Divider, Menu, FormControlLabel, Checkbox, RadioGroup, Radio, Skeleton } from '@mui/material';
// import { FilterIcon, Wishlist } from '../../../Svg';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllProductsByCategory, getFilteredProducts, getMaximumAmountOfProduct, getSubCategoryNames, resetFilterOptionsForCategory, setClearFilteredProducts, setFilterValuesCate } from '../../../../redux/productsSlice';
import { getProfile, } from '../../../../redux/userSlice';
import { addWishlist, getAllWishlist } from '../../../../redux/wishlistSlice';
import { setVisible } from '../../../../redux/authModelSlice';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import styles from './SearchedProduct.module.css'
import { FilterIcon, Wishlist } from '../../../../Svg';
import ErrorData from '../../../pages/errorpage/ErrorData';
import breadcrumbStyle from '../../../components/maincomps/breadcrumbs/breadcrumbs.module.css'
import api from '../../../../helper/Api';
import Loader from '../../Loader/Loader';
import { useCurrency } from '../../../context/CurrencyContext';


const SearchedProduct = () => {
    const sortingOptions = [
        {
            name: 'defaultSorting',
            label: 'Default Sorting'
        },
        {
            name: 'readyToShip',
            label: 'Ready To ship'
        },
        {
            name: 'madeToOrder',
            label: 'Made to order'
        },
        {
            name: 'priceHighToLow',
            label: 'Price - high to low'
        },
        {
            name: 'priceLowToHigh',
            label: 'Price - low to high'
        },

    ];
    const { id } = useParams();
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search);
    const query = queryParams.get("query")
    const item = location?.state;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    const [sort, setSort] = useState("");
    const [loading, setLoading] = useState(false);
    const { productsByCategoryData, categoryNamesData, isLoading, isFilterLoading, filterOptionsForCategory, isRefresh, filteredProductData, maximumAmountOfProductData } = useSelector((state) => state.products);
    const { formatPrice } = useCurrency();

    const maxPriceProduct = maximumAmountOfProductData?.pricing?.finalSalePrice?.value || 10000000;
    const { wishlistData } = useSelector((state) => state.wishlist)
    const wishlistRefresh = useSelector((state) => state.wishlist.isRefresh)
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [priceRange, setPriceRange] = useState([100000, maxPriceProduct]);
    const [anchorElSorting, setAnchorElSorting] = useState(null);
    const [selectedSort, setSelectedSort] = useState("defaultSorting");
    const token = localStorage.getItem("token");

    useEffect(() => {

        const fetchProduct = async () => {
            window.scrollTo(0, 0);
            try {
                setLoading(true);
                const body = {
                    query: query,
                    sortBy: sort
                }

                const queryStr = new URLSearchParams(body).toString();
                const { data, status } = await api.getProductsBySearch(queryStr)

                if (status === 200) {
                    setLoading(false)
                    setProducts(data)
                }
            } catch (err) {
                setLoading(false);
            }
        }

        if (query) {
            fetchProduct();
        }
    }, [query, sort])


    useEffect(() => {
        dispatch(resetFilterOptionsForCategory())
        // dispatch(setClearFilteredProducts())
        dispatch(getAllProductsByCategory(id))

    }, [dispatch, id]);

    useEffect(() => {
        if (filterOptionsForCategory) {
            dispatch(getFilteredProducts({ ...filterOptionsForCategory, categoryId: id }));
        }
    }, [dispatch, filterOptionsForCategory, id]);


    useEffect(() => {
        dispatch(getMaximumAmountOfProduct())
    }, [dispatch])

    useEffect(() => {
        if (maxPriceProduct) {
            setPriceRange([100000, maxPriceProduct]);
        }
    }, [maxPriceProduct]);

    //Filter Categories
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const handleCategoryChange = (category) => {
        setSelectedCategories((prevSelected) => {
            let updatedCategories;

            if (prevSelected.some(item => item.categoryId === category.categoryId)) {
                updatedCategories = prevSelected.filter(item => item.categoryId !== category.categoryId);
            } else {
                updatedCategories = [...prevSelected, category];
            }

            // Extract only category IDs to send to Redux
            const categoryIds = updatedCategories.map(item => item.categoryId);

            dispatch(setFilterValuesCate({ subcategory: categoryIds }));
            return updatedCategories;
        });
    };


    const handlePriceChange = (event, newValue) => {
        // console.log('newValue===========',newValue);

        setPriceRange(newValue);
        // Convert array to string format "min-max"
        const priceRangeString = `${newValue[0]}-${newValue[1]}`;

        dispatch(setFilterValuesCate({ priceRange: priceRangeString }));
    };

    const handleClearAll = () => {
        setSelectedCategories([]); // Reset categories to default "All Product"
        setPriceRange([100000, maxPriceProduct]);
        dispatch(resetFilterOptionsForCategory())
        // dispatch(getFilteredProducts({ categoryId: id}));
        dispatch(getAllProductsByCategory(id)) // Fetch all products again
    };

    const handleApply = () => {
        handleClose(); // Close dropdown after applying
    };


    //Sorting
    const openSorting = Boolean(anchorElSorting);

    const handleClickSorting = (event) => {
        setAnchorElSorting(event.currentTarget);
        // setSort(event)
        // dispatch(setFilterValuesCate({ sortBy: event }))
    };

    const handleCloseSorting = () => {
        setAnchorElSorting(null);
    };

    const handleSortChange = (event) => {
        setSelectedSort(event.target.value);
        setSort(event.target.value);
        // dispatch(setFilterValuesCate({ sortBy: event.target.value }))
        handleCloseSorting();
    };

    useEffect(() => {
        let data = `?categoryId=${id}`
        dispatch(getSubCategoryNames(data))
    }, [dispatch, id]);

    useEffect(() => {
        dispatch(getProfile())
    }, [dispatch])


    useEffect(() => {
        dispatch(getAllWishlist())

    }, [dispatch, wishlistRefresh])

    const handleWishlist = async (value) => {
        let data = {
            productId: value,
            quantity: 1
        }
        dispatch(addWishlist(data))

    }


    return (
        <div>
            <div className={styles.query}>
                <div className={styles.showingText}>
                    Showing {products?.length || 0} results{query ? ` for "${query}"` : ""}
                </div>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {/* Trigger Button */}
                    <Button
                        variant="outlined"
                        endIcon={<KeyboardArrowDownIcon />}
                        onClick={handleClickSorting}
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            color: "#000",
                            borderColor: "#ddd",
                            backgroundColor: "#fff",
                            minWidth: '160px',
                        }}
                    >
                        {sort === 'readyToShip' ? 'Ready to ship'
                            : sort === 'madeToOrder' ? 'Made to order'
                                : sort === 'priceHighToLow' ? 'Price high to low'
                                    : sort === 'priceLowToHigh' ? 'Price low to high'
                                        : " Default sorting"
                        }

                    </Button>

                    {/* Menu */}
                    <Menu
                        anchorEl={anchorElSorting}
                        open={openSorting}
                        onClose={handleCloseSorting}
                        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                        transformOrigin={{ vertical: "top", horizontal: "center" }}
                        PaperProps={{
                            sx: {
                                borderRadius: "8px",
                                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                p: 2,
                                minWidth: "200px",
                                marginLeft: "-20px",
                            },
                        }}
                    >
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontWeight: "bold", mb: 1 }}
                        >
                            SORT BY
                        </Typography>
                        <RadioGroup value={selectedSort} onChange={handleSortChange}>
                            {sortingOptions.map((option) => (
                                <FormControlLabel
                                    key={option}
                                    value={option?.name}
                                    defaultChecked={true}
                                    control={<Radio
                                        sx={{
                                            color: "#999", // Default color
                                            "&.Mui-checked": {
                                                color: "#000", // Custom checked color
                                                // backgroundColor:'#EFEEF1'
                                            },
                                        }}
                                    />}
                                    label={option?.label}
                                    sx={{
                                        "& .MuiFormControlLabel-label": {
                                            fontSize: "0.875rem",
                                        },
                                        "& .MuiSvgIcon": {
                                            fill: 'red'
                                        },
                                        "&.Mui-checked": {
                                            // color: "#000", // Custom checked color
                                            backgroundColor: '#EFEEF1'
                                        },
                                    }}
                                />
                            ))}
                        </RadioGroup>
                    </Menu>
                </Box>
            </div>


            {(loading || !products) ? (
                <Loader />
            ) : (
                <>
                    {products?.length > 0 ? (
                        <Box sx={{ padding: '16px 8%' }}>
                            <Grid container spacing={3}>
                                {products?.map((product) => {
                                    const isWishlisted = Array.isArray(wishlistData)
                                        ? wishlistData.some((item) => item?.productId === product?._id)
                                        : false
                                    return (
                                        <Grid item xs={12} sm={6} md={4} key={product._id} >
                                            <Card
                                                sx={{ position: 'relative', borderRadius: '0px', }}

                                            >

                                                {/* Tag */}
                                                {product?.discount === 0 ? (
                                                    null
                                                ) : (
                                                    <Chip
                                                        label={`${product?.discount}% off`}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: '8px',
                                                            left: '8px',
                                                            backgroundColor: '#FEF5EB',
                                                            color: '#000',
                                                        }}
                                                    />
                                                )}


                                                <Box
                                                    sx={{ height: '320px', backgroundColor: '#000', boxSizing: 'border-box' }}
                                                    onClick={() => {
                                                        navigate(`/prodDescription/${product?._id}`)
                                                        window.scrollTo(0, 0);
                                                    }}
                                                >
                                                    <CardMedia
                                                        component="img"
                                                        image={product?.featurerdImage}
                                                        alt={product?.productName}
                                                        sx={{ objectFit: 'contain', height: '100%', width: '100%', backgroundColor: '#000', cursor: 'pointer' }}
                                                    />
                                                </Box>

                                                {/* Product Details */}
                                                <CardContent sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                                                    <Box>
                                                        <Typography variant="h6" component="div" gutterBottom>
                                                            {product?.productName}
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', gap: '8px', alignItems: "flex-end" }}>
                                                            {/* <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                                ₹{product?.sellingPrice?.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            </Typography> */}
                                                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                                {formatPrice(product?.sellingPrice)}
                                                            </Typography>
                                                            {product?.discount === 0 ? (
                                                                null
                                                            ) : (
                                                                // <Typography
                                                                //     variant="body2"
                                                                //     sx={{ textDecoration: 'line-through', color: 'gray', }}
                                                                // >
                                                                //     ₹{product?.totalPrice?.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                // </Typography>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{ textDecoration: 'line-through', color: 'gray', }}
                                                                >
                                                                    {formatPrice(product?.totalPrice)}
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    </Box>
                                                    <Box
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            if (token) {
                                                                handleWishlist(product?._id);
                                                            } else {
                                                                dispatch(setVisible('signin'))
                                                            }
                                                        }}
                                                    // onClick={handleWishlist}
                                                    >
                                                        {/* <Wishlist color = {'white'} borderColor ={'black'}/> */}
                                                        <Wishlist color={isWishlisted ? 'red' : 'white'} borderColor={isWishlisted ? 'red' : 'black'} />
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                        </Box>
                    ) : products?.length === 0 ? (
                        <ErrorData />
                    ) : (<> </>)}
                </>
            )}
        </div>
    )
}

export default SearchedProduct